<template>
	<div class="row items-center full-height">
		<div class="col-12">
			<object class="flash">
				<embed :src="getResource" />
			</object>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FlashPlayer',

	props: ['activity'],

	data() {
		return {
			id_course: '',
			id_trail: '',
		}
	},

	computed: {
		getResource() {
			if (this.activity.resource) return `${this.activity.resource}`
			else return ''
		},
	},

	methods: {
		sendPosition() {
			let fd = new FormData()
			fd.append('id_group_training_module', this.activity.type_id)

			let url = ''
			if (this.id_trail === '')
				url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
			else
				url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`

			this.$axios
				.post(url, fd)
				.then((response) => {
					this.updatePosition()
				})
				.catch((e) => {
					console.log(e)
				})
		},

		updatePosition() {
			if (!this.activity.user_watch) {
				setTimeout(() => {
					this.$store.dispatch('activities/SET_ACTIVITY_DATA', [
						this.activity,
						{ user_watch: true },
					])
					this.$emit('finish')
				}, 500)
			}
		},
	},

	created() {
		if (this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
		if (this.$route.params.id) this.id_course = this.$route.params.id
		this.sendPosition()
	},
}
</script>

<style lang="scss" scoped>
.flash {
	embed {
		width: 100%;
		height: 60vh;
	}
}
</style>
